<div class="news">
  <div class="news__header">
    <h3 class="typography-title-s">{{ 'news.title' | translate }}</h3>
  </div>

  <div class="news__list">
    <div *ngFor="let card of newsCards; let i = index"
         class="news__item">

        <div class="news__thumb">
            <img [src]="card.image" [alt]="card.title" class="news__img" />
        </div>

        <div class="news__body">
            <div class="typography-title-s">{{ card.title }}</div>
            <div class="news__actions">
                <button class="news__btn" (click)="$event.stopPropagation(); card.action ? card.action() : null">
                    {{ 'news.action-button' | translate }}
                </button>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
            </div>
        </div>

    </div>
  </div>
</div>


